console.log('custom js loaded');

window.addEventListener('DOMContentLoaded', function() {
    var contactForm = document.getElementById('form_template--21839371895125__form'); 

    if (contactForm) {
        contactForm.addEventListener('submit', function(event) {
            // Invia l'evento 'submit_contact_form' al dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'submit_contact_form'
            });
        });
    }
});

window.addEventListener('DOMContentLoaded', function() {
    var newsletterForm = document.getElementById('ContactFooter');

    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(event) {
            // Invia l'evento 'submit_newsletter_form' al dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'submit_newsletter_form'
            });
        });
    }
});

window.addEventListener('DOMContentLoaded', function() {
    var createCustomerForm = document.getElementById('createCustomer');
    var loginCustomerForm = document.getElementById('loginCustomer');

    if (createCustomerForm) {
        createCustomerForm.addEventListener('submit', function(event) {
            event.preventDefault();
            // Invia l'evento 'sign_up' al dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'sign_up'
            });
            console.log('Sign up event pushed:', window.dataLayer);
            // Puoi aggiungere qui il codice per inviare il modulo se necessario
        });
    }

    if (loginCustomerForm) {
        loginCustomerForm.addEventListener('submit', function(event) {
            event.preventDefault();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
               'event': 'login'
            });
            console.log('Login form submitted:');
            console.log(window.dataLayer);
        });
    }
});


window.addEventListener('DOMContentLoaded', function() {
    // Verifica se la pagina è una pagina di listing
    if (document.body.id == 'template-collection') {
        window.dataLayer = window.dataLayer || [];
        
        // Array per memorizzare tutti gli oggetti
        var itemsArray = [];
        
        // Ottieni tutti i prodotti presenti nella pagina di listing
        var products = document.querySelectorAll('.collection_products_item');

        // Itera su ogni prodotto nella lista e aggiungi le informazioni
        products.forEach(function(product, index) {
          //console.log(product);
          
            var item = {
                'item_id': product.dataset.sku,
                'item_name': product.dataset.name,
                'affiliation': product.dataset.affiliation,
                'coupon': '', // Assicurati di sostituire con il valore appropriato
                'currency': product.dataset.currency,
                'discount': (product.dataset.comparePrice - product.dataset.price) / 100, 
                'index': index + 1,
                'item_brand': product.dataset.vendor,
                'item_category': product.dataset.type,
                'item_category2': '',
                'item_category3': '',
                'item_category4': '',
                'item_category5': '',
                'item_list_id': product.dataset.collectionid,
                'item_list_name': product.dataset.collectiontitle,
                'item_variant': '',
                'location_id': '',
                'price': product.dataset.price,
                'quantity': 1
            };
            itemsArray.push(item);
          //console.log(item);
        });
        
        // Aggiungi l'array di oggetti all'evento 'view_item_list'
        window.dataLayer.push({
            'event': 'view_item_list',
            'ecommerce': {
                'item_list_id': Shopify.collectionId,
                'item_list_name': Shopify.collectionTitle,
                'items': itemsArray
            }
        });
    }
});

/* $(document).ready(function() {
    $('a[href*="/products/"]').on('click', function() {
        // Estrai i dati del prodotto dal link
        var productUrl = $(this).attr('href');
        var productId = productUrl.split('/').pop();
        var productName = $(this).text();
        var productPrice = parseFloat($(this).data('price'));
        var productSku = $(this).data('sku');
        var productCategory = $(this).data('category');
        var productBrand = $(this).data('brand');
        var productDiscount = parseFloat($(this).data('discount'));
        var productPosition = $(this).index() + 1;

        // Push dei dati del prodotto al dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'select_item',
            'ecommerce': {
                'item_list_id': 'ID_LISTA',
                'item_list_name': 'NOME_LISTA',
                'items': [{
                    'item_id': productId,
                    'item_name': productName,
                    'affiliation': 'AFFILIAZIONE',
                    'currency': 'VALUTA',
                    'discount': productDiscount,
                    'index': productPosition,
                    'item_brand': productBrand,
                    'item_category': productCategory,
                    'item_variant': 'VARIANTE',
                    'location_id': 'POSIZIONE',
                    'price': productPrice,
                    'quantity': 1
                }]
            }
        });
    });
}); */

document.addEventListener('DOMContentLoaded', function() {
  var cartItems = document.querySelectorAll('.cart-item');
  var itemsArray = [];
  //var couponCode = document.getElementById('couponCode').dataset.coupon;
  var currencyCode = document.getElementById('currencyCode').dataset.currency;

  cartItems.forEach(function(itemElement) {
    var item = {
      'item_id': itemElement.dataset.sku,
      'item_name': itemElement.dataset.title,
      'coupon': couponCode,
      'item_brand': itemElement.dataset.vendor,
      'item_category': itemElement.dataset.type,
      'price': itemElement.dataset.price,
      'quantity': itemElement.dataset.quantity
    };
    itemsArray.push(item);
  });

  // Push dei dati del carrello al dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'add_shipping_info',
    'ecommerce': {
      'currency': 'EUR',
      'items': itemsArray
    }
  });
});



